import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import MeusCursosMain from '../components/meus-cursos';

const MeusCursos = () => {
  return (
    <Wrapper>
      <SEO pageTitle={'Meus Cursos'} />
      <MeusCursosMain/>
    </Wrapper>
  );
};

export default MeusCursos;